import React from "react";
import { motion } from "framer-motion";

const steps = [
  { n: "01", title: "Scope", desc: "We map your idea into a lean, shippable build in a quick call.", time: "Day 0" },
  { n: "02", title: "Design", desc: "Distinctive UI/UX + brand, generated and refined fast.", time: "Day 0–1" },
  { n: "03", title: "Build", desc: "Full-stack engineering with AI baked in. You watch it come alive.", time: "Day 1–7" },
  { n: "04", title: "Deploy", desc: "Production-ready, one-click deployable. Live and yours.", time: "Ship day" },
];

export default function Process() {
  return (
    <section id="process" className="py-24 relative border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon-cyan mb-3">// how we move</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
            From idea to live in <span className="text-neon-yellow">days.</span>
          </h2>
        </div>

        <div className="grid gap-5 md:grid-cols-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-2xl border border-white/10 bg-surface p-7 hover:border-neon-cyan/40 transition-colors"
            >
              <div className="font-mono text-5xl font-bold text-white/10">{s.n}</div>
              <h3 className="mt-4 text-lg font-bold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-white/55 leading-relaxed">{s.desc}</p>
              <div className="mt-5 inline-block font-mono text-xs uppercase tracking-wider text-neon-cyan border border-neon-cyan/20 rounded-full px-3 py-1">
                {s.time}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
